export class AuthUserInfo {
  public client_id: string;
  public email: string;
  public name: string;
  public role: string;
  public sub: string;
  public wli_associnfo_associationverticaltype: string;
  public wli_associnfo_associationverticaltypeid: string;
  public wli_associnfo_timezone: string;
  public wli_associnfo_timezoneoffset: string;
  public wli_associnfo_orgname: string;
  public wli_customer_id: string;
  public wli_profileid: string;
  public wli_tenant: string;
  public wli_tenant_http_url: string;
  public wli_tenant_https_url: string;
  public wli_user_access_type: string;
  public wli_user_type: string;
  public wli_username: string;
  public wli_usernum: string;
  public wli_corp_profileid: string;

  public constructor() {
    this.client_id = '';
    this.email = '';
    this.name = '';
    this.role = '';
    this.sub = '';
    this.wli_associnfo_associationverticaltype = '';
    this.wli_associnfo_associationverticaltypeid = '';
    this.wli_associnfo_timezone = '';
    this.wli_associnfo_timezoneoffset = '';
    this.wli_associnfo_orgname = '';
    this.wli_customer_id = '';
    this.wli_profileid = '';
    this.wli_tenant = '';
    this.wli_tenant_http_url = '';
    this.wli_tenant_https_url = '';
    this.wli_user_access_type = '';
    this.wli_user_type = '';
    this.wli_username = '';
    this.wli_usernum = '';
    this.wli_corp_profileid = '';
  }
}
